import { combineReducers } from 'redux';
import userReducer from './user';
import authReducer from './authReducer';
import appReducer from './app';
import sensorReducer from './sensorReducer';
import performanceReducer from './performanceReducer';
import blockdate from './blockdate';
import rappelsReducer from './rappelsReducer';
import shiftsReducer from './shiftsReducer';

/*export default combineReducers authentification user app  sensorReducer performanceReducer blockdate rappelsReducer 


export default combineReducers({
  authentification: authReducer,
  user: userReducer,
  app: appReducer,
  sensorReducer: sensorReducer,
  performanceReducer: performanceReducer,
  blockdate: blockdate,
  rappelsReducer: rappelsReduce


*/

export default combineReducers({
  authentification: authReducer,
  user: userReducer,
  app: appReducer,
  sensorReducer: sensorReducer,
  performanceReducer: performanceReducer,
  blockdate: blockdate,
  rappelsReducer: rappelsReducer,
  shiftsReducer: shiftsReducer,
});


